import {
  NamedRoute,
  route,
} from "../../../application/domain/routing/named-route";
import { LoginPage } from "./index";
import { LoginTOTPPage } from "./login-mfa";
import { toQueryString } from "../../../utils/url-utils";
import { Route } from "react-router";
import { SSOLoginPage } from "./login-sso";
import { SSOLoginErrorPage } from "./login-sso-error";
import { RequestPasswordResetPage } from "./request-password-reset";
import { ResetPasswordPage } from "./reset-password";

export const LoginR = {
  Login: route({
    path: "/login",
    link: (args: { to?: string }) =>
      `/login${toQueryString({
        to: args.to ? encodeURIComponent(args.to) : undefined,
      })}`,
    component: LoginPage,
  }),
  LoginMFA: route({
    path: "/login/mfa",
    component: LoginTOTPPage,
  }),
  LoginSSO: route({
    path: "/login/sso",
    component: SSOLoginPage,
  }),
  LoginSSOError: route({
    path: "/login/sso/error",
    component: SSOLoginErrorPage,
  }),
  RequestTmpResetPassword: route({
    path: "/request-password-reset",
    component: RequestPasswordResetPage,
  }),
  ResetPassword: route({
    path: "/reset-password",
    component: ResetPasswordPage,
  }),
};

export const LoginRoutes = () => {
  return (
    <>
      {Object.keys(LoginR).map((k: string) => {
        const r = (LoginR as { [key: string]: NamedRoute<any> })[k].forRouter;
        return (
          <Route
            exact
            path={r.path}
            component={r.component}
            key={`LoginRoute-${k}`}
          />
        );
      })}
    </>
  );
};
